document.addEventListener("ShoptetDOMPageContentLoaded", function () {
  customProduct();
});
document.addEventListener("ShoptetPageSortingChanged", function () {
  customProduct();
});
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
  customProduct();
});
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
  customProduct();
});
$(document).ready(function () {
  customProduct();
});

function customProduct() {
  if ($(".products").length) {
    $(".product").each(function () {
      const $product = $(this);
      if ($product.find(".widget-parameter-wrapper").length) {
        $product
          .find("a.image")
          .append(
            '<span class="choose btn btn-conversion">' +
              translation("vybratvariantu") +
              "</span>",
          );
      } else {
        $product
          .find("a.image")
          .append(
            '<span class="choose btn btn-conversion cartButton">' +
              translation("koupit") +
              "</span>",
          );
      }

      const $availability = $product.find(".availability");
      if ($availability.length) {
        $availability.appendTo($product.find('.p-in div[data-micro="offer"]'));
      }

      const $flagDiscount = $product.find(
        ".flags-extra .flag-discount .price-standard",
      );
      const $prices = $product.find(".prices");

      if (
        $flagDiscount.length &&
        $prices.length &&
        !$prices.find(".price-standard").length
      ) {
        $flagDiscount.clone().prependTo($prices);
      }

      const $starsWrapper = $product.find(".stars-wrapper");

      if ($starsWrapper.length && !$starsWrapper.find(".rating-meta").length) {
        const ratingValue = $starsWrapper.data("micro-rating-value");
        const ratingCount = $starsWrapper.data("micro-rating-count");

        if (ratingValue && ratingCount !== undefined) {
          // skloňování "recenze / recenzí"
          const reviewText = ratingCount <= 4 ? "recenze" : "recenzí";

          const ratingHtml = `
          <div class="rating-meta">
            <strong>${ratingValue} z 5</strong>
            <span>${ratingCount} ${reviewText}</span>
          </div>
        `;

          $starsWrapper.append(ratingHtml);
        }
      }

      const availabilityText = $product
        .find(".availability > span:not(.availability-amount)")
        .text()
        .trim()
        .toLowerCase();

      const deliveryDate = getDeliveryDateByAvailability(availabilityText);
      if (!deliveryDate) return;

      const formatted = formatDeliveryDate(deliveryDate);

      if (!$product.find(".deliveryDate").length) {
        $product
          .find(".availability")
          .append(`<div class="deliveryDate">${formatted} u tebe</div>`);
      }
    });
  }

  if ($(".availability-amount").length) {
    $(".availability-amount").each(function () {
      var text = $(this).text();
      text = text.replace(/[()]/g, "");
      $(this).text(text);
    });
  }
}

$("html").on("click", ".products .product .cartButton", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var productCode = $(this)
    .closest(".product")
    .find('span[data-micro="sku"]')
    .text()
    .trim();
  shoptet.cartShared.addToCart({ productCode: "" + productCode + "" });

  // advanced order
  const $product = $(this).closest(".product");
  lastProductData = {
    image:
      $product.find(".image img").attr("data-micro-image") ||
      $product.find(".image img").attr("src"),
    price: $product.find(".prices").html(),
    priceSave: $product.find(".price-save").text(),
    amount: parseInt($(this).find('input[name="amount"]').val()) || 1,
  };
});
